import { supabase } from '@/core/database/supabase';
import type { NotificationItem, NotificationStatus } from '../types/notifications.types';

export const NotificationsService = {
  /**
   * Lấy danh sách thông báo của user
   */
  async getNotifications(userId: string, limit = 50): Promise<NotificationItem[]> {
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return data as NotificationItem[];
  },

  /**
   * Đánh dấu đã đọc
   */
  async markAsRead(id: string): Promise<void> {
    const { error } = await supabase
      .from('notifications')
      .update({ 
        status_code: 'read', 
        read_at: new Date().toISOString() 
      })
      .eq('id', id);

    if (error) throw error;
  },

  /**
   * Đánh dấu tất cả đã đọc
   */
  async markAllAsRead(userId: string): Promise<void> {
    const { error } = await supabase
      .from('notifications')
      .update({ 
        status_code: 'read', 
        read_at: new Date().toISOString() 
      })
      .eq('user_id', userId)
      .eq('status_code', 'unread');

    if (error) throw error;
  },

  /**
   * Đăng ký nhận thông báo realtime
   */
  subscribe(userId: string, onUpdate: (payload: any) => void) {
    return supabase
      .channel(`user-notifications-${userId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`
        },
        onUpdate
      )
      .subscribe();
  }
};
